import { Outlet, useMatch } from "react-router";
import "./assets/css/App.css";
import { Sidebar } from "./components/sidebar/Sidebar";
import { ROUTE_PATTERNS } from "./shared/routes";

const AppContainer = () => {
  const isSignIn = useMatch(ROUTE_PATTERNS.SIGN_IN);
  const isInvitation = useMatch(ROUTE_PATTERNS.INVITATION);

  if (isSignIn || isInvitation) {
    return <Outlet />;
  }

  return (
    <div className="app-container">
      <Sidebar />
      <div className="app-right">
        <div className="app-page">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppContainer;
